import { render } from "./S930_LieferantenDokumentUpload.vue?vue&type=template&id=1ecb33a2&scoped=true&ts=true"
import script from "./S930_LieferantenDokumentUpload.vue?vue&type=script&lang=ts"
export * from "./S930_LieferantenDokumentUpload.vue?vue&type=script&lang=ts"

import "./S930_LieferantenDokumentUpload.vue?vue&type=style&index=0&id=1ecb33a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecb33a2"]])

export default __exports__